<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">订单[{{ json.Orders_SN }}]发货申请信息</div>
            <div class="mb20" v-if="zeropay">
                <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="分款记录">
                        <div>
                            <div style="margin-top: 10px">
                                <el-table :data="CabinetSupplierList" ref="Table" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Receipt_ID" label="ID" width="120" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_BandName" label="汇入银行" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Code" label="汇款单位" align="center" width="300" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_TotalAmount" label="汇款金额" align="center">
                                        <template slot-scope="scope">
                                            <div>￥{{ scope.row.Receipt_TotalAmount }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Receipt_Amount" label="分款金额" align="center">
                                        <template slot-scope="scope">
                                            <div>￥{{ scope.row.Receipt_Amount }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Receipt_Amount" label="分配金额" align="center">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.Receipt_ShowAmount" placeholder="请输入" clearable class=""></el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="mb20">
                <div class="mb20">
                    <el-button type="primary" @click="rmaQuery()">挪货销账查询</el-button>
                    <div class="mb20 mt20" v-if="rma_noList && rma_noList.length > 0">
                        <el-table :data="rma_noList" ref="Table" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column prop="CATALOG_DESC" label="销售件描述" align="center" width="450"></el-table-column>
                            <el-table-column prop="RMA_LINE_NO" label="RAM行号" align="center"></el-table-column>
                            <el-table-column prop="RMA_NO" label="退货单号" align="center"></el-table-column>
                            <el-table-column prop="CATALOG_NO" label="零件号" align="center"></el-table-column>
                            <el-table-column prop="LINE_NO" label="行号" align="center"></el-table-column>
                            <el-table-column prop="REL_NO" label="下达号" align="center"></el-table-column>
                            <el-table-column prop="Transfer_Quantity" label="本次挪货数量" align="center"></el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="deleteRma_noList(scope.row, scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="mb20">
                    <el-table :data="GoodsList.Goods" ref="Table" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="Goods_Product_Name" label="商品名称" align="center" width="500" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Goods_Product_Code" label="商品编码" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_Spec" label="商品规格" align="center" width="350" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Goods_Amount" label="购买数量" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_Price" label="单价" align="center">
                            <template slot-scope="scope">
                                <span class="red">￥{{ getFloat(scope.row.Goods_Product_Price, 2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_FreightAmount" label="已申请数量" align="center" width="140"></el-table-column>
                        <el-table-column prop="Goods_DeliveryAmount" label="本次发货数量" align="center" width="160">
                            <template slot-scope="scope">
                                <div v-if="scope.row.Goods_DeliveryAmountInput == 'true' && isReturnGoods != 1">
                                    <el-input v-model="scope.row.Goods_DeliveryAmount" placeholder="请输入" @blur="DeliveryAmount(scope.row, scope.row.Goods_DeliveryAmount, $event)" clearable class=""></el-input>
                                </div>
                                <div v-else>
                                    {{ scope.row.Goods_DeliveryAmount || 0 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_TotalPrice" label="合计" align="center">
                            <template slot-scope="scope">
                                <span class="red">￥{{ getFloat(scope.row.Goods_TotalPrice, 2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="totalBox">
                        发货额:
                        <span class="red">￥{{ getFloat(GoodsList.Orders_Price, 2) }}</span>
                    </div>
                </div>
            </div>
            <div class="mb20">
                <el-descriptions title="" :column="1" size="medium" labelClassName="custom-labelnullBor" contentClassName="custom-contentnullBor">
                    <el-descriptions-item label="配送方式">
                        <div>
                            <span style="margin-right: 10px">{{ json.Orders_Delivery_Name }}</span>
                            <el-checkbox v-model="Apply_IsAllReach"></el-checkbox>
                            <span class="red">所有货物必须一次发货</span>
                            <span class="grey">一次发货需待所有货物备齐后统一发货，发货周期可能会延长</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="货发配电柜厂家">
                        <div>
                            <el-select v-model="json.CabinetSupplier" placeholder="请选择" style="width: 800px">
                                <el-option v-for="item in SupplierList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            &nbsp;
                            <el-input v-model="SupplierName" placeholder="货发配电柜厂家名称搜索" clearable class="el-select-medium"></el-input>
                            &nbsp;
                            <el-button type="primary" @click="CabinetSupplier_Select">查询</el-button>
                            <span class="grey">使用选择配电柜厂家地址作为收货地址</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="省份">
                        <div>
                            <el-select v-model="Orders_Address_Country" placeholder="请选择国家" class="el-select-medium" disabled>
                                <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                            </el-select>
                            &nbsp;
                            <el-select v-model="json.Orders_Address_State" placeholder="请选择省" class="el-select-medium" @change="provinceChange" disabled clearable filterable>
                                <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                            </el-select>
                            &nbsp;
                            <el-select v-model="json.Orders_Address_City" placeholder="请选择市/地区" class="el-select-medium" @change="cityChange" clearable filterable :disabled="orderInfo.Orders_Address_State != '1' && orderInfo.Orders_Address_State != '2' && orderInfo.Orders_Address_State != '3' && orderInfo.Orders_Address_State != '4'">
                                <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                            </el-select>
                            &nbsp;
                            <el-select v-model="json.Orders_Address_County" placeholder="请选择区/县" class="el-select-medium" clearable filterable>
                                <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                            </el-select>
                            <span class="required">*</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="收货地址">
                        <div>
                            <el-input v-model="json.Orders_Address_StreetAddress" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <span class="required">*</span>
                            <span class="grey">非指定配电柜厂家修改有效</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="收货人姓名">
                        <div>
                            <el-input v-model="json.Orders_Address_Name" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <span class="required">*</span>
                            <span class="grey">多个收货人姓名之间以“;”号分隔</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="联系电话">
                        <div>
                            <el-input v-model="json.Orders_Address_Phone_Number" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <span class="grey">多个联系电话之间以“;”号分隔</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="手机">
                        <div>
                            <el-input v-model="json.Orders_Address_Mobile" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <span class="required">*</span>
                            <span class="grey">多个手机之间以“;”号分隔</span>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="button-container">
                <el-button type="primary" @click="submit(1)">保存草稿</el-button>
                <el-button type="primary" @click="submit(0)">提交</el-button>
            </div>
            <el-dialog :visible.sync="rma_noShow" title="挪货销账查询" width="1200px" :close-on-click-modal="false" append-to-body>
                <div class="mb20">
                    <el-input v-model="rma_no" placeholder="请输入退货单号" clearable class="el-select-medium"></el-input>
                    <el-button style="margin-left: 20px" type="primary" @click="rmaQueryList" :loading="loading">查询</el-button>
                </div>
                <div class="mb20" v-if="rma_noData && JSON.stringify(rma_noData) != '{}'">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="退货单号">
                            <div class="rows">{{ rma_noData.RMA_NO }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单号">
                            <div class="rows">{{ rma_noData.ORDER_NO }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="分支机构">
                            <div>{{ rma_noData.REGION_CODE }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="销售员编号">
                            <div>{{ rma_noData.SALESMAN_Name }}[{{ rma_noData.SALESMAN_CODE }}]</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="工程名称">
                            <div>{{ rma_noData.Project_Name }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <div v-else>
                    <div class="error">请输入退货单号检索</div>
                </div>
                <el-table v-if="rma_noData.Detail" :data="rma_noData.Detail" ref="Table" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column prop="CATALOG_DESC" label="销售件描述" align="center" width="450"></el-table-column>
                    <el-table-column prop="RMA_LINE_NO" label="RAM行号" align="center"></el-table-column>
                    <el-table-column prop="CATALOG_NO" label="零件号" align="center"></el-table-column>
                    <el-table-column prop="QTY_TO_RETURN" label="退货数量" align="center"></el-table-column>
                    <el-table-column prop="Rma_ApplyAmount" label="本次可挪货数量" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.QTY_TO_RETURN - (scope.row.Apply_QTY || 0) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Transfer_Quantity" label="本次挪货数量" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.Transfer_Quantity" placeholder="请输入" clearable class="" @input="MoveGoodsQuantity"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="button-container" v-if="rma_noData && JSON.stringify(rma_noData) != '{}'">
                    <el-button type="primary" @click="moveGoods">确认挪货</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'orderDelivery',
    props: {
        OrdersID: {
            type: [String, Number],
            default: ''
        },
        isReturnGoods: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            // OrdersID: '', //合同id
            batchOrderId: '', //当前选中的订单id
            relate_orders: [],
            list: [],
            orderInfo: {}, //订单信息
            json: {
                Orders_SN: '',
                Orders_Address_StreetAddress: '',
                Orders_Address_Name: '',
                Orders_Address_Phone_Number: '',
                Orders_Address_Mobile: '',
                Orders_Delivery_Name: '',
                Apply_OrdersID: '',
                Orders_Address_City: '',
                Orders_Address_State: '',
                Orders_Address_County: '',
                CabinetSupplier: '0'
            },
            Orders_Address_State: '',
            Orders_Address_Country: '1',
            cityListopt: [],
            districtListopt: [],
            cartListInfo: {
                Orders_ID: '',
                Orders_IsAllFreight: '',
                Orders_Addtime: '',
                mannue: 0
            },
            rma_noShow: false,
            moveLiveIndex: 0,
            ramJosn: {
                rma_no: '',
                apply_ordersid: '',
                addtime: ''
            },
            Apply_IsAllReach: false,
            SupplierList: [],
            SupplierName: '',
            rma_no: '', //挪货订单号
            rma_noData: {}, //挪货
            rma_noList: [], //挪货列表
            SupplierIndex: 0,
            zeropay: false,
            CabinetSupplierList: [],
            GoodsList: [],
            screenShow: false,
            loading: false // 按钮加载状态
        };
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.deliveryProvinceList,
            cityList: (state) => state.common.deliveryCityList,
            districtList: (state) => state.common.deliveryDistrictList
        })
    },
    async mounted() {
        await this.$store.dispatch('fetchLocationData');
        if (this.OrdersID) {
            this.json.Apply_OrdersID = this.OrdersID;
            this.CheckOrdersFreight();
        }
        this.CabinetSupplier_Select();
    },
    methods: {
        //
        async CheckOrdersFreight() {
            let result = await this.$newsApi.order.CheckOrdersFreight({
                OrdersID: this.OrdersID,
                ifBack: true
            });
            if (result.data.Resultinfo == 'true') {
                this.zeropay = true;
            }
            this.orderInfo = result.data.data;
            this.json = {
                Orders_SN: this.orderInfo.Orders_SN,
                Orders_Address_StreetAddress: this.orderInfo.Orders_Address_StreetAddress,
                Orders_Address_Name: this.orderInfo.Orders_Address_Name,
                Orders_Address_Phone_Number: this.orderInfo.Orders_Address_Phone_Number,
                Orders_Address_Mobile: this.orderInfo.Orders_Address_Mobile,
                Orders_Delivery_Name: this.orderInfo.Orders_Delivery_Name,
                Orders_Address_City: this.orderInfo.Orders_Address_City,
                Orders_Address_State: this.orderInfo.Orders_Address_State,
                Orders_Address_County: this.orderInfo.Orders_Address_County,
                Apply_OrdersID: this.OrdersID,
                CabinetSupplier: this.json.CabinetSupplier || '0'
            };
            this.Orders_Address_State = '' + this.orderInfo.Orders_Address_State;
            this.cartListInfo.Orders_ID = this.orderInfo.Orders_ID;
            this.cartListInfo.Orders_IsAllFreight = this.orderInfo.Orders_IsAllFreight;
            this.cartListInfo.Orders_Addtime = this.orderInfo.Orders_Addtime;

            const orderRequests = [this.$newsApi.order.OrdersDistributeReceiptChecked({ OrdersID: this.OrdersID, Apply_ID: -1 }), this.Orders_Delivery_Goods_Select()];
            const [CabinetSupplierList] = await Promise.all(orderRequests);
            this.CabinetSupplierList = CabinetSupplierList.data.data;
            this.provinceChangeBegin('' + this.orderInfo.Orders_Address_State);
            this.cityChangeBegin('' + this.orderInfo.Orders_Address_City);
             // 验证并清空不存在的绑定值
            if (!this.isValueExistInOptions(this.json.Orders_Address_State, this.provinceList)) {
                this.json.Orders_Address_State = '';
                this.json.Orders_Address_City = '';
                this.json.Orders_Address_County = '';
            }
            if (!this.isValueExistInOptions(this.json.Orders_Address_City, this.cityListopt)) {
                this.json.Orders_Address_City = '';
                this.json.Orders_Address_County = '';
            }
            if (!this.isValueExistInOptions(this.json.Orders_Address_County, this.districtListopt)) {
                this.json.Orders_Address_County = '';
            }
        },
        isValueExistInOptions(value, optionsList, codeField = 'Code') {
            if (!value || !optionsList || !Array.isArray(optionsList)) {
                return false;
            }
            return optionsList.some((item) => item[codeField] == value);
        },
        // 获取商品清单
        async Orders_Delivery_Goods_Select() {
            let result = await this.$newsApi.order.Orders_Delivery_Goods_Select({ json: JSON.stringify(this.cartListInfo), rmaorderdetails: this.rma_noList });
            this.GoodsList = result.data.data;
        },
        // 点击挪货查询
        rmaQuery() {
            this.rma_no = '';
            this.rma_noData = {};
            this.rma_noShow = true;
        },
        // 保存
        async submit(e) {
            let needJson = JSON.parse(JSON.stringify(this.json));

            // 循环添加分款记录
            let CabinetSupplierList = this.CabinetSupplierList;
            for (let i = 0; i < CabinetSupplierList.length; i++) {
                needJson['Rec_Amount_' + CabinetSupplierList[i].Receipt_ID] = CabinetSupplierList[i].Receipt_ShowAmount;
            }
            // 循环添加商品清单
            let GoodsList = this.GoodsList.Goods;
            for (let i = 0; i < GoodsList.length; i++) {
                needJson['ProductAmount_' + GoodsList[i].Goods_ID] = GoodsList[i].Goods_DeliveryAmount;
            }
            // 配电柜厂家
            needJson.CabinetSupplier = this.json.CabinetSupplier;
            // 配送方式
            needJson.Apply_IsAllReach = this.Apply_IsAllReach ? 1 : 0;
            this.json = needJson;
            if (this.GoodsList.Goods && this.rma_noList && this.rma_noList.length > 0 && this.GoodsList.Goods.length > 0) {
                let moveGoodsShow = false;
                let MoreThan = 0;
                this.GoodsList.Goods.forEach((item, index) => {
                    this.rma_noList.forEach((iten, indx) => {
                        if (item.Goods_Product_Code == iten.CATALOG_NO && !moveGoodsShow) {
                            if (item.Goods_DeliveryAmountMAX < item.Goods_DeliveryAmount) {
                                MoreThan = item.Goods_DeliveryAmountMAX;
                                moveGoodsShow = true;
                            }
                        }
                    });
                });
                if (moveGoodsShow) {
                    this.$message(`超过了最大发货数量（${MoreThan}）`);
                    return;
                }
            }
            this.OrdersDeliveryApplyAdd(e, 1);
        },
        // 保存发货申请
        async OrdersDeliveryApplyAdd(e, i) {
            var Json = JSON.stringify(this.json);
            var result = await this.$newsApi.order.OrdersDeliveryApplyAdd({
                ischeck: i == 1 ? true : false,
                Json: Json,
                SourceType: 'PC',
                rmaorderdetails: this.rma_noList,
                istemporary: e || 0
            });
            if (i == 1) {
                if (result.data.Resultcode == 2) {
                    this.$confirm(result.data.Resultinfo, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.OrdersDeliveryApplyAdd(e, 2);
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });
                }
                if (result.data.Resultcode == 0) {
                    this.OrdersDeliveryApplyAdd(e, 2);
                }
            }

            if (i == 2) {
                if (result.data.Resultcode == 0) {
                    this.$message('操作成功');
                    // this.$router.go(-1);
                    this.$emit('orderDeliveryRes'); // 关闭弹窗
                }
            }
        },

        //选择市
        cityChange(e) {
            this.districtListopt = [];
            this.json.Orders_Address_County = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
        },
        provinceChange(e) {
            this.cityListopt = [];
            this.json.Orders_Address_City = '';
            this.districtListopt = [];
            this.json.Orders_Address_County = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        //选择市
        cityChangeBegin(e) {
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
        },
        provinceChangeBegin(e) {
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        async CabinetSupplier_Select() {
            let result = await this.$newsApi.order.CabinetSupplier_Select({ CabinetSupplier_Name: this.SupplierName });
            if (result.data.data) {
                let arr = [];
                this.SupplierList = [{ label: '未选择', value: '0' }];
                for (let key in result.data.data) {
                    let obj = {};
                    obj.label = result.data.data[key];
                    obj.value = String(key);
                    arr.push(obj);
                }
                let data = arr.reverse();
                this.SupplierList = this.SupplierList.concat(data);
                if (this.SupplierName && data.length > 0) {
                    this.json.CabinetSupplier = data[0].value;
                } else {
                    this.json.CabinetSupplier = '0';
                }
                this.SupplierIndex = this.SupplierName != '' ? 1 : 0;
            } else {
                let arr = [];
                this.SupplierList = [{ label: '未选择', value: '0' }];
            }
        },
        // 挪货销账查询
        async rmaQueryList() {
            let data = {
                rma_no: this.rma_no,
                apply_ordersid: this.json.Apply_OrdersID,
                addtime: this.cartListInfo.Orders_Addtime
            };
            let Json = JSON.stringify(data);
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 5000); // 设置超时时间为5秒
            let res = await this.$newsApi.order.GetRMAOrderList({
                Json: Json
            });
            this.loading = false;
            if (res.data.Resultcode == '0') {
                this.rma_noData = res.data.data;
                this.screenShow = true;
            }
        },
        // 填写挪货数量
        MoveGoodsQuantity() {
            this.rma_noData.Detail.map((item) => {
                if (item.Transfer_Quantity > item.QTY_TO_RETURN - (item.Apply_QTY || 0)) {
                    this.$message.error('挪货数量不能大于可挪货数量');
                    item.Transfer_Quantity = item.QTY_TO_RETURN - (item.Apply_QTY || 0);
                }
                return item;
            });
        },
        // 确认挪货
        async moveGoods() {
            try {
                let obj = {};
                let arr = [];
                if (this.rma_noData.Detail) {
                    this.rma_noData.Detail.forEach((item, index) => {
                        arr.push(item.CATALOG_NO + '|' + item.RMA_LINE_NO);
                        obj[`returnamount_${item.CATALOG_NO}|${item.RMA_LINE_NO}`] = item.Transfer_Quantity;
                    });
                }
                let catalog_no = arr.join(',');
                let data = {
                    rma_no: this.rma_no,
                    apply_ordersid: this.json.Apply_OrdersID,
                    addtime: this.cartListInfo.Orders_Addtime,
                    catalog_no: catalog_no,
                    ...obj
                };
                let Json = JSON.stringify(data);
                let res = await this.$newsApi.order.CheckRMAOrderDetails({
                    Json: Json,
                    rmaorderdetails: this.rma_noList
                });
                if (res.data.Resultcode == '0') {
                    this.rma_noList = res.data.data;
                    this.cartListInfo.mannue = 0;
                    this.Orders_Delivery_Goods_Select();
                    // this.$message.success('挪货成功');
                }
            } catch (error) {
                this.$message.error('请求失败');
            } finally {
                // 确保关闭弹窗
                this.rma_noShow = false;
                this.screenShow = false;
            }
        },
        // 发货数量输入事件
        async DeliveryAmount(e, i) {
            let copyGoods_ID = e.Goods_ID;
            let copyGoods_DeliveryAmount = i;
            let Things = this.GoodsList.Goods;
            this.cartListInfo.mannue = 1;
            for (let i = 0; i < Things.length; i++) {
                if (Things[i].Goods_DeliveryAmount > Things[i].Goods_DeliveryAmountMAX) {
                    Things[i].Goods_DeliveryAmount = Things[i].Goods_DeliveryAmountMAX;
                }
                this.cartListInfo['ProductAmount_' + Things[i].Goods_ID] = Things[i].Goods_DeliveryAmount;
            }
            await this.Orders_Delivery_Goods_Select();
            if (this.GoodsList.Goods) {
                let nowDeliveryAmount = this.GoodsList.Goods.find((item) => item.Goods_ID == copyGoods_ID).Goods_DeliveryAmount;
                if (Number(nowDeliveryAmount) < Number(copyGoods_DeliveryAmount)) {
                    this.$alert(`超过最大发货数量(${nowDeliveryAmount})`, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
            }
        },
        deleteRma_noList(row, index) {
            this.rma_noList.splice(index, 1);
            this.Orders_Delivery_Goods_Select();
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}

::v-deep .hw-content .custom-labelnullBor {
    width: 120px;
    color: #333;
    min-height: 42px;
    line-height: 42px;
    display: inline-block;
    text-align: right !important;
}
::v-deep .hw-content .custom-contentnullBor {
    min-height: 42px;
    line-height: 42px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
    font-weight: 700;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
.totalBox {
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-top: 0;
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
}
.grey {
    color: grey;
    margin-left: 10px;
}
.content,
.hw-content,
/* 允许弹窗内容滚动 */
::v-deep .el-dialog__body {
    overflow-y: auto !important;
    max-height: calc(90vh - 120px);
}
</style>